var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef, memo } from "react";

var SvgPause = function SvgPause(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 18,
    width: 2,
    height: 2,
    transform: "rotate(-90 6.5 18)",
    fill: "#111111"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 18,
    width: 2,
    height: 2,
    transform: "rotate(-90 12.5 18)",
    fill: "#111111"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(-90 6.5 10)",
    fill: "#111111"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 10,
    width: 2,
    height: 2,
    transform: "rotate(-90 12.5 10)",
    fill: "#111111"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 14,
    width: 2,
    height: 2,
    transform: "rotate(-90 6.5 14)",
    fill: "#111111"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 14,
    width: 2,
    height: 2,
    transform: "rotate(-90 12.5 14)",
    fill: "#111111"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 2,
    height: 2,
    transform: "rotate(-90 6.5 6)",
    fill: "#111111"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4,
    width: 2,
    height: 2,
    transform: "rotate(-90 6.5 4)",
    fill: "#111111"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 6,
    width: 2,
    height: 2,
    transform: "rotate(-90 12.5 6)",
    fill: "#111111"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 4,
    width: 2,
    height: 2,
    transform: "rotate(-90 12.5 4)",
    fill: "#111111"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 12,
    width: 2,
    height: 2,
    transform: "rotate(-90 6.5 12)",
    fill: "#111111"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 2,
    height: 2,
    transform: "rotate(-90 12.5 12)",
    fill: "#111111"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 16,
    width: 2,
    height: 2,
    transform: "rotate(-90 6.5 16)",
    fill: "#111111"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 16,
    width: 2,
    height: 2,
    transform: "rotate(-90 12.5 16)",
    fill: "#111111"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 8,
    width: 2,
    height: 2,
    transform: "rotate(-90 6.5 8)",
    fill: "#111111"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8,
    width: 2,
    height: 2,
    transform: "rotate(-90 12.5 8)",
    fill: "#111111"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";